import React from 'react'
import cx from 'classnames'
import Charts from './charts'
import Layout from '../layout'
import Match from 'lib/components/match'
import ReturnsText from '../returns-text'
import Sidebar from './aggregate/sidebar'
import SidebarDetail from './aggregate/sidebar-detail'
import Toolbar from '../toolbar'
import MobileToolbar from '../toolbar-mobile'
import XYScatterPlot from './charts/x-y-scatterplot'
import { getFactorChartTitle } from '../../config/viewing-label'

class FactorsAggregate extends React.PureComponent {
  renderSidebar() {
    let { query, aggregate } = this.props

    return <Sidebar query={query} factors={aggregate} />
  }

  renderSidebarOrDetail() {
    if (this.props.activeAggregate) {
      return this.renderSidebarDetail()
    }

    return this.renderSidebar()
  }

  renderSidebarDetail() {
    let { region, activeAggregate } = this.props

    return activeAggregate ? (
      <SidebarDetail activeAggregate={activeAggregate} region={region} />
    ) : null
  }

  getCurrentAggregate(name) {
    let { query, aggregate } = this.props

    let currentAggregate = aggregate

    if (query.expanded !== name && query.category) {
      currentAggregate = aggregate.filter(a => a.Category === query.category)
    }

    return currentAggregate
  }

  getChartTitle() {
    return getFactorChartTitle(this.props)
  }

  getViewingTitle() {
    return getFactorChartTitle({ ...this.props, region: null })
  }

  renderChart(name, expanded) {
    const { query, series, aggregate, factorCorrelations } = this.props

    const title = expanded ? this.getChartTitle() : null

    return (
      <Charts
        name={name}
        query={query}
        series={series}
        title={title}
        aggregate={aggregate}
        currentAggregate={this.getCurrentAggregate(name)}
        factorCorrelations={factorCorrelations}
        expanded={expanded}
      />
    )
  }

  getExpandedChart() {
    const { expanded, selected } = this.props.query

    if (!expanded || (expanded === 'timeSeriesChart' && !selected)) {
      return null
    }

    return this.renderChart(expanded, true)
  }

  render() {
    const { aggregate, query, region } = this.props

    const lastCellContents =
      query.category && query.selected ? (
        this.renderChart('timeSeriesChart')
      ) : (
        <ReturnsText type="factors" />
      )

    const lastCellClassname = cx('cell', {
      '-returns-text': !(query.category && query.selected),
      'track-as-chart-panel': query.category && query.selected
    })

    return (
      <Layout query={query} region={region} section="factors">
        <Match max="small-max">
          <MobileToolbar region={region} viewing={this.getViewingTitle()}>
            {this.renderSidebar()}
          </MobileToolbar>
        </Match>

        <Match min="medium-min">{this.renderSidebarOrDetail()}</Match>

        <main className="main">
          <Toolbar region={region} section="factors" />

          <Match max="small-max">{this.renderSidebarDetail()}</Match>

          <div className="charts">
            <div className="charts__main">
              {this.getExpandedChart()}

              <div className="charts__main__default">
                <XYScatterPlot
                  title={this.getChartTitle()}
                  data={aggregate}
                  query={query}
                />
              </div>
            </div>

            <div className="charts__footer">
              <div className="cell track-as-chart-panel" data-track="valuation chart">
                {this.renderChart('valuationBoxPlot')}
              </div>

              <div className="cell track-as-chart-panel" data-track="implementation chart">
                {this.renderChart('correlationChart')}
              </div>

              <div className={lastCellClassname} data-track="time series chart">
                {lastCellContents}
              </div>
            </div>
          </div>
        </main>
      </Layout>
    )
  }
}

export default FactorsAggregate



// WEBPACK FOOTER //
// ./src/components/factors/aggregate.js